export type IAttendance = "N/A" | "Arrive" | "Late" | "Reschedule" | "No Show" | "Cancel";

export interface IAttachment {
  driveId: string;
  name: string;
  mimeType: string;
  size?: number;

  viewUrl: string;
  webViewLink: string;
  webContentLink?: string;
  
  streamUrl?: string;
  dashManifestUrl?: string
  uploadedAt: string | Date;

}

export interface IBooking {
    // will add more to this
    bookingId?: string
    serviceIds: string[], 
    serviceNames: string[],
    studentIds: string[],
    teacherId: string,
    startTime: Date,
    endTime: Date,
    duration: number, // in minutes
    title: string,
    description?: string,
    status: "pending" | "confirmed" | "finished" | "cancelled",
    attendance?: IAttendance,
    createdAt?: Date,
    updatedAt?: Date | null,
    recurrenceType?: 'daily' | 'weekly' | 'biweekly' | 'monthly' | 'none';
    recurrenceCount?: number;
    recurrenceId?: string;
    feedback?: string;

    attachments?: IAttachment[];
    confirmed?: boolean;

    folderId?: string,
}

export const defaultBooking: IBooking = {
  // will add more to this
  bookingId: "",
  serviceIds: [], 
  serviceNames: [],
  studentIds: [],
  teacherId: "",
  startTime: new Date(0),
  endTime: new Date(0),
  duration: 0, // in minutes
  title: "",
  description: "",
  status: "pending",
  feedback: "",

  attachments: [],
  confirmed: false,

  folderId: "",
}


export const AttendanceOptions: IAttendance[] = [
  "N/A", "Arrive", "Late", "Reschedule", "No Show", "Cancel"
]